<template>
  <div class="box box--wrapper section-client_list">
    <div class="box-title">
      <h2>COMPANIES EXPERIENCE</h2>
    </div>
    <div class="text--center text--header">
      <p>Thanks to my previous experience, I had the opportunity to works for these companies below.</p>
    </div>
    <div class="box-content text--center">
      <div class="row">
        <div class="col-3" :class="[{ 'is--empty':!client.img }]" v-for="(client, index) in clients" :key="index">
          <a :href="client.link" target="_blank">
            <img :src="`/static/img/${client.img}`" :alt="client.name" v-if="client.img"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    clients() {
      return this.$store.getters.getClients;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/common/Clients.vue